import { Component } from '@angular/core';
import { LoyaltyMode } from '@app/core/redux/stores';
import { ModalService } from '@core/services';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-visit-tutorial',
  templateUrl: './visit-tutorial.component.html',
  styleUrls: ['./visit-tutorial.component.less']
})
export class VisitTutorialComponent {
  public customModalDialogClass = 'visitTutorialModalOverride ';
  public loyaltyMode: LoyaltyMode;
  public LoyaltyMode = LoyaltyMode;
  constructor(private modalService: ModalService) { 
    this.loyaltyMode = environment.LOYALTY_MODE;
  }

  dismiss(): void {
    this.modalService.hideModal();
  }

}
